import SessionForm from '../../components/SessionForm';
import TableEditor from '../../components/TableEditor';
import GroupLabel from '../../components/GroupLabel';
import { Table } from '../../components/';
import { createOrmActions, editorPropTypes } from '../../components/common';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

const SessionEditorColumns = ({ children }) => (
  <Fragment>
    <colgroup>
      <col style={{ width: 'calc(2ch + 2em)' }} />
      <col />
      <col style={{ width: 'calc(3ch + 1em)' }} />
      <col />
      <col style={{ width: '8ch' }} />
    </colgroup>
    {children}
  </Fragment>
);

const SessionsEditorHeader = ({ children }) => (
  <Fragment>
    <Table.Row>
      <Table.HeaderCell>
        <abbr title="Number">Nr</abbr>
      </Table.HeaderCell>
      <Table.HeaderCell>Title</Table.HeaderCell>
      <Table.HeaderCell />
      <Table.HeaderCell>Groups</Table.HeaderCell>
      <Table.HeaderCell>Entries</Table.HeaderCell>
      {children}
    </Table.Row>
  </Fragment>
);

const SessionsEditorRow = ({ row, meta, children }) => (
  <Table.Row warning={!row.entries.length}>
    <Table.Cell>{row.number}</Table.Cell>
    <Table.Cell>{row.title}</Table.Cell>
    <Table.Cell>{row.groups.length}</Table.Cell>
    <Table.Cell>
      {row.groups.map(group => (
        <GroupLabel key={group.id} group={group} meta={meta} size="small" />
      ))}
    </Table.Cell>
    <Table.Cell>{row.entries.length}</Table.Cell>
    {children}
  </Table.Row>
);

const SessionsEditor = ({ id, sessions, actions, meta }) => {
  const defaultValues = {
    number: '',
    title: '',
    groups: [],
  };

  const rows = sortBy(sessions, 'number').map(session => ({
    ...session,
    key: session.primaryKey,
    description: `session ${session.number}`,
    currentValues: {
      number: session.number || '',
      title: session.title || '',
      groups: session.groups.map(({ primaryKey }) => primaryKey),
    },
  }));

  // TODO: Display projected session sizes.
  // TODO: Assign sessions based on earliest appearing contest + session size limit',

  return (
    <TableEditor
      id={id}
      Columns={SessionEditorColumns}
      Header={SessionsEditorHeader}
      Row={SessionsEditorRow}
      rows={rows}
      Form={SessionForm}
      defaultValues={defaultValues}
      actions={createOrmActions(actions, rows)}
      meta={meta}
    />
  );
};

SessionsEditor.propTypes = {
  ...editorPropTypes,
  sessions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SessionsEditor;



// WEBPACK FOOTER //
// ./src/pages/Schedule/SessionsEditor.js